import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import {
    //createFieldCheckbox,
    createFieldInput,
    createFieldSelect,
    createFieldTemplateBuilder,
    createFieldRadioGroup, createFieldCheckbox
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { isOperationAndSubStanceTypeMain } from "../request.section";
import { callCountry } from "../haz-discuss-info/haz-discuss-info.section";
import { callHazSubStanceType } from "../../../haz/request/haz-info/haz-info.section";

const HazDiscussMainSubStanceList = defineAsyncComponent(() => import("./HazDiscussMainSubStanceList"));
const HazDiscussAquaticList = defineAsyncComponent(() => import("./HazDiscussAquaticList"));

export const callLd50 = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/ld50/cacheFindAll", { where: [{ name: "nameTh", operator: "like", value: searchQuery }] });
export const callOperator = ({ searchQuery }) => ["=", "!=", ">", "<", ">=", "<="].filter(d => d.includes(searchQuery || ""));
export const callPictogram = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/pictogram/cacheFindAll", { where: [{ name: "name", operator: "like", value: searchQuery }] });
export const callSubStanceTypeMain = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SUB_STANCE_TYPE_MAIN", value: searchQuery });
export const callToUse = ({ searchQuery }) => 
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_PRODUCT_USE_DISCUSS", value: searchQuery})

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}tradeNameTh`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.tradeNameTh"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.tradeNameTh,
                                        "onUpdate:value": value => (model.tradeNameTh = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}customsCoordinates`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.customsCoordinates"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.customsCoordinates,
                                        "onUpdate:value": value => (model.customsCoordinates = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldTemplateBuilder({
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.hazInfo.nature"),
                            inputProp: () => ({
                                useForm: useForm,
                                fields: [
                                    createFieldCheckbox({
                                        visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                        key: `${prefix}isSolid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.isSolid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    checked: model.isSolid,
                                                    "onUpdate:checked": checked => {
                                                        model.isSolid = checked;
                                                        if (checked) {
                                                            model.isLiquid = false;
                                                            model.liquid = null;
                                                        }
                                                    },
                                                    disabled: viewOnly,
                                                    text: () => i18n.global.t("model.haz.isSolid")
                                                },
                                                conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                                            )
                                    }),
                                    createFieldInput({
                                        visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                        key: `${prefix}solid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.solid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    value: model.solid,
                                                    "onUpdate:value": value => (model.solid = value),
                                                    disabled: viewOnly || !model.isSolid
                                                },
                                                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                            )
                                    }),
                                    createFieldCheckbox({
                                        visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                        key: `${prefix}isLiquid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.isLiquid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    checked: model.isLiquid,
                                                    "onUpdate:checked": checked => {
                                                        model.isLiquid = checked;
                                                        if (checked) {
                                                            model.isSolid = false;
                                                            model.solid = null;
                                                        }
                                                    },
                                                    disabled: viewOnly,
                                                    text: () => i18n.global.t("model.haz.isLiquid")
                                                },
                                                conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                                            )
                                    }),
                                    createFieldInput({
                                        visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                        key: `${prefix}liquid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.liquid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    value: model.liquid,
                                                    "onUpdate:value": value => (model.liquid = value),
                                                    disabled: viewOnly || !model.isLiquid
                                                },
                                                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                            )
                                    })
                                ],
                                skeleton: isLoading.value
                            })
                        }),
                    ],
                    skeleton: isLoading.value
                })
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}tradeNameEn`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.tradeNameEn"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.tradeNameEn,
                                        "onUpdate:value": value => (model.tradeNameEn = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}manufacturer`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.manufacturer"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.manufacturer,
                                        "onUpdate:value": value => (model.manufacturer = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refCountry`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.refCountry"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refCountry,
                                        "onUpdate:value": value => (model.refCountry = value),
                                        disabled: viewOnly,
                                        list: callCountry,
                                        renderLabel: ({ item }) => (
                                            <span>
                                                { item.nameEnS } : { item.nameTh }
                                            </span>
                                        ),
                                        optKey: "id"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refToUse`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.refToUse"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refToUse,
                                        "onUpdate:value": value => {
                                            const oldValue = model.refToUse;
                                            model.refToUse = value;
                                            if (oldValue != value && oldValue?.key == "5") {
                                                model.otherToUse = null;
                                            }
                                        },
                                        disabled: viewOnly,
                                        list: callToUse,
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}otherToUse`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.otherToUse"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.otherToUse,
                                        "onUpdate:value": value => (model.otherToUse = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                    ]
                })
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSubStanceTypeMain`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.haz.refSubStanceTypeMain"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSubStanceTypeMain,
                            "onUpdate:value": value => {
                                const oldValue = model.refSubStanceTypeMain;
                                model.refSubStanceTypeMain = value;
                                clearSubStanceMain({ modelRef, model });
                                if (
                                    (["micro"].includes(oldValue?.key) && !["micro"].includes(value?.key)) ||
                                    (!["micro"].includes(oldValue?.key) && ["micro"].includes(value?.key))
                                ) {
                                    model.mainSubStances.forEach(mainSubStance => {
                                        if (mainSubStance.refSubStance?.refType?.key !== "media") {
                                            mainSubStance.refSubStance = null;
                                        }
                                    });
                                }
                                if (!["chemi"].includes(value?.key)) {
                                    model.isTechnicalGrade = false;
                                }
                            },
                            disabled: viewOnly,
                            list: callHazSubStanceType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isTechnicalGrade`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 }, colon: false }),
                label: () => i18n.global.t("model.haz.isTechnicalGrade"),
                labelRender: () => " ",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isTechnicalGrade,
                            "onUpdate:checked": checked => (model.isTechnicalGrade = checked),
                            disabled: viewOnly || !["chemi"].includes(model.refSubStanceTypeMain?.key),
                            text: () => i18n.global.t("model.haz.isTechnicalGrade")
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}mainSubStances`,
                            fetchCriteria: data.mainSubStance?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "HazDiscussMainSubStanceList" } })
                    );
                    return <HazDiscussMainSubStanceList {...componentProp}></HazDiscussMainSubStanceList>;
                }
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemRender: () => <div class="text-bold text-16">{i18n.global.t("model.hazDiscussAquatic.modelName")}</div>
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}aquatics`,
                            fetchCriteria: data.aquatic?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "HazDiscussAquaticList" } })
                    );
                    return <HazDiscussAquaticList {...componentProp}></HazDiscussAquaticList>;
                },
            }
        ]
    });
};


export const clearSubStanceMain = ({ modelRef, model }) => {
    if (
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi" }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemiTechnicalGrade" }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" })
    ) {
        model.mainSubStances.forEach(mainSubStance => {
            //lodash.remove(mainSubStance.companies, company => !company.id).forEach(company => (company.isDelete = true));
            //lodash.remove(mainSubStance.products, product => !product.id).forEach(product => (product.isDelete = true));
            mainSubStance.refSubStance = null;
            mainSubStance.otherSubStance = null;
        });
    }
    if (
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi" }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemiTechnicalGrade" }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "2", subStanceTypeMain: "chemi" }) ||
        isOperationAndSubStanceTypeMain({ modelRef, operation: "2", subStanceTypeMain: "chemiTechnicalGrade" })
    ) {
        model.mainSubStances.forEach(mainSubStance => {
            mainSubStance.microAnalysisResult1 = null;
            mainSubStance.microAnalysisResult2 = null;
            mainSubStance.microAnalysisResult3 = null;
            mainSubStance.microAnalysisQty1 = null;
            mainSubStance.microAnalysisQty2 = null;
            mainSubStance.microAnalysisQty3 = null;
            mainSubStance.refMicroUnit = null;
            /*if (!mainSubStance.qty) {
                mainSubStance.refUnit = null;
            }*/
        });
    }
};
